import { Outlet } from "react-router-dom";
import { ScrollTop } from "@/components/commons/ScrollTop";
import { InitSetupProvider } from "@/providers/InitSetupProvider";
import { LoadingArea } from "@/components/elements/Loading/Loading";
import { MobileLayoutProps } from "@/components/layout/MobileLayout/MobileLayout.types";
import { MobileBottomNav } from "@/components/layout/MobileLayout/MobileBottomNav";
import { LayoutShell, LayoutRoot, SafeAreaTop, MockExamMainContainer } from "@/components/layout/MobileLayout/mobile-layout.styles";

export const MockExamMobileLayout = ({ bottomNav = false, isLoading, children }: MobileLayoutProps) => {
  const content = (
    <LayoutShell>
      <LayoutRoot>
        <ScrollTop />
        <SafeAreaTop />
        <MockExamMainContainer>
          {isLoading ? (
            <LoadingArea />
          ) : (
            <>
              <Outlet />
              {children}
            </>
          )}
        </MockExamMainContainer>
      </LayoutRoot>
      {bottomNav && <MobileBottomNav />}
    </LayoutShell>
  );

  if (bottomNav) {
    return <InitSetupProvider>{content}</InitSetupProvider>;
  }

  return content;
};
